import { render } from "./time-confirm.view.vue?vue&type=template&id=1f872a67&scoped=true&ts=true"
import script from "./time-confirm.view.vue?vue&type=script&lang=ts"
export * from "./time-confirm.view.vue?vue&type=script&lang=ts"

import "./time-confirm.view.vue?vue&type=style&index=0&id=1f872a67&lang=scss&scoped=true"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f872a67"]])

export default __exports__